import { getProfileFirebase } from "../libs/firebase";

const userInformation = {
    isLoaded: false,
    userId: null,
    email: null,
    authToken: null,
    businessId: null,
};

const loadUserInformation = async () => {
    if (userInformation.isLoaded) {
        return;
    }

    const { user } = await getProfileFirebase();
    userInformation.userId = user?.userId;
    userInformation.email = user?.email;
    userInformation.authToken = user?.authtoken;
    userInformation.businessId = user?.businessId;
    userInformation.isLoaded = true;
};

const setNewToken = (newToken) => {
    userInformation.authToken = newToken;
};
const getUserId = async () => {
    await loadUserInformation();
    return userInformation.userId;
};

const getUserEmail = async () => {
    await loadUserInformation();
    return userInformation.email;
};

const getUserAuthToken = async () => {
    await loadUserInformation();
    return userInformation.authToken;
};

const getUserBusinessId = async () => {
    await loadUserInformation();
    return userInformation.businessId;
};

const isSuperAdmin = async () => {
    // Hardcoded now but delete later in that story: https://masandpas.atlassian.net/browse/LPPT-4431
    // Currently this is using Sophia user id in production.
    const superAdminId = "cf5ae3d0";
    return await getUserId() === superAdminId;
};

const userMixin = {
    methods: {
        getUserId,
        getUserEmail,
        getUserAuthToken,
        getUserBusinessId,
        isSuperAdmin,
        setNewToken,
    },
};

export default userMixin;
